/*
 * Laboté — Consultation Beauté (V2)
 * Expérience conversationnelle avec l'experte beauté virtuelle Laboté.
 *
 * Parcours : question ouverte (« quelle est votre première préoccupation ? »)
 * → diagnostic (questionnaire du sur-mesure, produit non encore choisi)
 * → routine de produits du catalogue (moteur consultation-reco.js)
 * → soin sur-mesure proposé en dernier, en prolongement de la routine.
 *
 * Dépend de window.LaboteEngine (consultation-engine.js) + window.LaboteQuizData
 * (consultation-data.js) + window.LaboteReco (consultation-reco.js) +
 * window.LaboteCatalogue (consultation-catalogue.js) + window.LaboteConfig (section liquid).
 * Divulgation IA : accueil + mention permanente (section liquid) — obligatoire.
 */
(function () {
  'use strict';

  var E = window.LaboteEngine;
  if (!E) { console.error('LaboteEngine manquant'); return; }
  var CFG = window.LaboteConfig || { products: {} };
  var AVATAR = CFG.avatar || 'https://labote.com/cdn/shop/files/Favicon_Labote_2024-02.png?width=96';

  // --- Analyse photo (P2) — Edge Function Supabase labote-drip, zéro rétention ---
  var VISION_URL = CFG.visionUrl || 'https://pemunjfbdosowlzmekdj.supabase.co/functions/v1/consultation-vision';
  var CHAT_URL = CFG.chatUrl || 'https://pemunjfbdosowlzmekdj.supabase.co/functions/v1/consultation-chat';
  var VISION_KEY = CFG.visionKey || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBlbXVuamZiZG9zb3dsem1la2RqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzkxNjY5MDMsImV4cCI6MjA5NDc0MjkwM30.G6JL5gfGmVQTIoBRCtWE1mIXye19B-3X_v2Nr6yvB_c';
  // nature apparente (vision) → options du type de peau à suggérer (jamais décidées à la place de la cliente)
  var NATURE_LABELS = {
    grasse: 'plutôt grasse ou sujette aux brillances',
    equilibree: 'plutôt équilibrée',
    seche: 'plutôt sèche ou en manque de confort',
  };
  var NATURE_SKIN_OPTIONS = { grasse: [0, 1, 2], equilibree: [3, 4], seche: [5, 6] };
  var CONCERN_QIDS = ['N1iez3V', 'wLiW3Jq', 'X8iAqn2'];
  var CONCERN_MAIN_QID = 'N1iez3V';

  // --- Recommandation catalogue (V2) ---
  var R = window.LaboteReco || null;
  // Le diagnostic est posé avant le choix d'un soin sur-mesure : les questions
  // sont celles communes aux trois soins, la personnalisation vient à la fin.
  var DIAG_PRODUCTS = ['daily_cream', 'night_cream', 'serum'];
  // Texte libre : disponible à tout moment, mais plafonné (décision Robin).
  var MAX_FREE_MESSAGES = 10;

  // --- Voix de l'experte (claims = textes du quiz + fiches produits, rien d'inventé) ---
  var S = {
    welcome: 'Bonjour 🤍 Je suis votre <b>experte beauté virtuelle Laboté</b>. En quelques questions, je vous compose <b>la routine qui correspond à votre peau</b> et, si vous le souhaitez, votre soin sur-mesure.',
    welcomeAsk: 'Pour commencer, dites-le-moi avec vos mots : <b>quelle est votre première préoccupation ?</b>',
    openHint: 'ou choisissez :',
    openPlaceholder: 'Écrivez-moi en quelques mots…',
    openConfirm: 'Si je comprends bien, c\'est surtout <b>{label}</b>. C\'est bien cela ?',
    openMulti: 'Je relève plusieurs choses. Qu\'est-ce qui vous gêne le plus au quotidien ?',
    openUnclear: 'Je ne suis pas sûre de bien saisir — dites-moi ce qui s\'en rapproche le plus :',
    openOther: 'Autre chose',
    freeAck: 'Merci, c\'est noté 🤍',
    freeAddConcern: 'Je peux aussi tenir compte de <b>{label}</b>. On l\'ajoute à votre profil ?',
    freeNoSlot: 'Je garde cela en tête. Nous avons déjà relevé vos trois préoccupations principales — c\'est ce qui guide votre routine.',
    freeUnknown: 'Je note 🤍 Pour vous conseiller au plus juste, reprenons la question en cours — vous pouvez m\'écrire à tout moment.',
    freeLimit: 'Nous avons bien échangé 🤍 Pour la suite, répondez-moi avec les propositions ci-dessous : c\'est ce qui me permet d\'être précise.',
    routineIntro: 'Voici la <b>routine Laboté</b> qui correspond à ce que vous m\'avez confié. Chaque soin est là pour une raison précise.',
    routineOutro: 'Vous pouvez ajouter toute la routine, ou seulement ce qui vous parle.',
    routineAdded: 'C\'est dans votre panier 🤍',
    routineEmpty: 'Votre peau n\'a pas besoin de grand-chose — commençons par l\'essentiel : un bon nettoyage.',
    surmesureOffer: 'Il reste une étape, celle que l\'on ne trouve nulle part ailleurs : <b>votre soin sur-mesure</b>, formulé à la demande dans notre laboratoire parisien avec les actifs que votre peau réclame. Je vous le compose ?',
    surmesureWhich: 'Que souhaitez-vous que je compose ?',
    surmesureNo: 'Une autre fois',
    surmesureYes: 'Oui, composons-le',
    surmesureDeclined: 'Très bien 🤍 Votre routine vous attend dans « Ma sélection » — et votre soin sur-mesure reste disponible quand vous le souhaiterez.',
    groupIntro: {
      skin_type: 'Commençons par votre peau : comment la sentez-vous au quotidien ?',
      concerns: null,
      moment_of_life: 'Parlons un peu de vous — cela m\'aide à ajuster votre formule.',
      reactions: null,
      habits: 'Vos habitudes de vie comptent aussi pour votre peau.',
      customization: 'Il ne reste que le plaisir : personnalisons votre soin ✨',
    },
    ackAdd: 'Parce que vous m\'avez indiqué « <b>{option}</b> », j\'ajoute à votre formule :',
    ackNoAdd: 'C\'est noté.',
    optionalHint: '(facultatif — vous pouvez passer)',
    skipLabel: 'Passer',
    validateLabel: 'Valider',
    noFragranceAdvice: {
      pregnant: 'Petit conseil : vous m\'avez dit être enceinte ou allaitante — je vous recommande la version <b>sans parfum</b>, les huiles essentielles sont déconseillées pendant cette période.',
      allergic: 'Petit conseil : votre peau est réactive — je vous recommande la version <b>sans parfum</b>.',
    },
    doneIntro: 'Votre formule est prête ✨ Voici votre bilan beauté personnalisé :',
    capture: 'Je vous ai réservé votre <b>offre de bienvenue</b> 🤍 Laissez-moi votre email : elle vous y attend, avec le détail de votre formule.',
    crossSell: {
      daily_cream: 'Et pour protéger votre peau la journée : je peux vous composer votre <b>crème de jour sur-mesure</b> avec ce que vous m\'avez déjà confié. On continue ?',
      night_cream: 'Et pendant votre sommeil : je peux vous composer votre <b>crème de nuit sur-mesure</b> avec ce que vous m\'avez déjà confié. On continue ?',
      serum: 'Pour aller au bout de votre rituel : votre peau adorerait un <b>sérum sur-mesure</b>, une double dose d\'actifs ciblés. Je vous le compose ?',
    },
    crossSellYes: 'Oui, créons-le', crossSellNo: 'Non merci',
    cartAdded: 'C\'est dans votre panier 🤍 Votre soin sera préparé à la demande dans notre laboratoire parisien.',
    photoOffer: 'Pour vous conseiller au plus juste, deux options : <b>montrez-moi votre peau en photo</b> 📸 — elle est analysée par notre IA puis <b>immédiatement supprimée</b> — ou répondez simplement à mes questions. Comme vous préférez !',
    photoConsent: 'En envoyant votre photo, vous acceptez son analyse automatisée par notre IA pour personnaliser nos recommandations. Elle est supprimée immédiatement après.',
    photoLooking: 'Je regarde ça…',
    photoCloser: 'Merci ! J\'aimerais voir votre peau d\'un peu plus près pour être sûre de moi 📸 Vous pouvez reprendre la photo, ou répondre à mes questions.',
    photoUnusable: 'Je n\'arrive pas à bien distinguer votre peau sur cette photo — passons par mes questions, c\'est tout aussi bien !',
    photoFail: 'Un petit souci technique de mon côté — continuons avec mes questions !',
  };

  var PRODUCT_CARDS = [
    { key: 'daily_cream', title: 'Crème de jour', desc: 'Pot 50 ml · protège votre peau la journée' },
    { key: 'night_cream', title: 'Crème de nuit', desc: 'Pot 50 ml · régénère pendant votre sommeil' },
    { key: 'serum', title: 'Sérum', desc: '30 ml · double dose d\'actifs ultra-ciblée' },
  ];
  var GROUP_LABELS = {
    skin_type: 'Votre type de peau', concerns: 'Vos préoccupations', moment_of_life: 'Votre moment de vie',
    reactions: 'Vos réactions', habits: 'Vos habitudes', customization: 'Votre personnalisation',
  };
  // Vignettes d'actifs (CDN Laboté — mêmes fichiers que le quiz de prod)
  var ACTIF_IMG_BASE = 'https://cdn.shopify.com/s/files/1/0696/5873/8901/files/';
  var ACTIF_IMG = {
    'Jojoba': 'Jojoba.png', 'Camélia': 'Camelia.png', 'Marula': 'Marula.png', 'Nigelle': 'Nigelle.png',
    'Onagre': 'Onagre_1.png', 'Pensée sauvage': 'Pensee_sauvage.png', 'Calendula': 'Calendula.png',
    'Réglisse': 'Reglisse.png', 'Bakuchiol': 'Bakuchiol.png', 'Centella': 'Centella_Asiatica.png',
    'Acmella': 'Acmella.png', 'Acérola': 'Acerola.png', 'Arnica': 'Arnica.png', 'Aloe vera': 'Aloe_vera.png',
    'Ginkgo': 'Ginkgo_biloba.png', 'Fucus': 'Fucus.png', 'Bardane': 'Bardane.png', 'Camomille': 'Camomille.png',
    'Consoude': 'Consoude_1.png', 'Céramides': 'Ceramides.png', 'Eau florale de bleuet': 'Bleuet_1.png',
  };
  function actifImg(name) { return ACTIF_IMG[name] ? ACTIF_IMG_BASE + ACTIF_IMG[name] + '?width=120' : ''; }

  // --- État ---
  var STORAGE_KEY = 'labote-consultation';
  var state = {
    // welcome → diagnostic → routine → surmesure → done
    phase: 'welcome',
    product: null,
    collected: [],            // enregistrements moteur (records)
    fragrance: null, texture: null,
    dateOfBirth: '', nameOnBox: '', note: '', additionalInformation: '', firstName: '',
    doneProducts: [],         // [{product, fragrance, texture}] terminés (cross-sell)
    qIndex: -1, pendingSubs: [], skipCount: 0, skippedQids: {},
    transcript: [], actions: [],
    startTracked: false, workerSent: false,
    inputMethod: 'questions',
    photoOffered: false, photoThumb: null, photoResult: null, photoRetryUsed: false,
    suggested: {}, autoConcerns: [],
    // V2 : recommandation catalogue + texte libre
    routine: null,             // résultat de LaboteReco.recommend
    routineCart: {},           // handles déjà ajoutés au panier
    freeCount: 0,              // messages libres consommés (plafond MAX_FREE_MESSAGES)
    openAnswered: false,       // la question ouverte d'accueil a été traitée
    surmesureOffered: false,
    captureShown: false,
  };
  var instant = false;

  var el = function (id) { return document.getElementById(id); };
  var esc = function (s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;'); };

  // Le diagnostic pose les questions communes aux trois soins (la personnalisation
  // — parfum, texture, gravure — n'arrive qu'au moment du sur-mesure).
  var diagCache = null;
  function diagnosticQuestions() {
    if (diagCache) return diagCache;
    var seen = {};
    diagCache = E.DATA.filter(function (q) {
      if ((q.group || '') === 'customization') return false;
      if (!DIAG_PRODUCTS.some(function (pr) { return (q.products || []).indexOf(pr) !== -1; })) return false;
      var k = qKey(q);
      if (seen[k]) return false;
      seen[k] = true;
      return true;
    });
    return diagCache;
  }
  function askQuestions() {
    if (state.phase === 'surmesure' && state.product) {
      return E.questionsFor(state.product).filter(function (q) { return (q.group || '') === 'customization'; });
    }
    return diagnosticQuestions();
  }

  // Les sauts « Aucune préoccupation » (+2 / +1 dans le quiz de prod) sont traduits
  // en questions nommées : la question ouverte peut répondre à la 1re préoccupation
  // hors de l'ordre du questionnaire, un saut par position serait alors faux.
  function applySkip(qid, option) {
    var n = E.skipAfter(qid, option);
    if (!n) return;
    var i = CONCERN_QIDS.indexOf(qid);
    if (i === -1) { state.skipCount += n; return; } // branche contour des yeux (dormante)
    for (var k = 1; k <= n; k++) {
      var next = CONCERN_QIDS[i + k];
      if (next) state.skippedQids[next] = true;
    }
  }
  function qKey(q) { return q.question_id || q.question; }
  function answeredQids() {
    var set = {};
    state.collected.forEach(function (r) { set[r.qid] = true; });
    return set;
  }

  // --- Rendu ---
  function bubbleExpert(html) { return '<div class="cb-msg"><img class="cb-avatar" src="' + AVATAR + '" alt="Experte virtuelle Laboté"><div class="cb-bubble">' + html + '</div></div>'; }
  function bubbleUser(html) { return '<div class="cb-msg cb-right"><div class="cb-bubble cb-user">' + html + '</div></div>'; }
  function bubbleTyping() { return '<div class="cb-msg"><img class="cb-avatar" src="' + AVATAR + '" alt=""><div class="cb-typing"><i></i><i></i><i></i></div></div>'; }

  function productCards() {
    return '<div class="cb-prodchips">' + PRODUCT_CARDS.map(function (c) {
      var p = E.getProduct(c.key, CFG);
      if (!p) return '';
      var img = p.image ? '<img src="' + p.image + '" alt="">' : '';
      var price = euros(productPriceCents(c.key, null, null));
      return '<button class="cb-prodcard" onclick="LaboteConsultation.chooseProduct(\'' + c.key + '\')">' + img +
        '<span class="cb-prodcard-t">' + c.title + '</span><span class="cb-prodcard-d">' + c.desc + '</span>' +
        '<span class="cb-prodcard-p">' + esc(price) + '</span></button>';
    }).join('') + '</div>';
  }

  // Mots-clés discriminants mis en gras dans les libellés (lecture agréable — le mot
  // qui distingue l'option des autres). Typographie uniquement : texte du quiz inchangé.
  var OPTION_KEYWORDS = [
    // type de peau
    /acnéique/i, /brillances importantes/i, /aspect brillant et luisant/i, /fin de journée/i,
    /Même sans soin/i, /textures légères/i, /["«»""]à boire["«»""]/i, /textures épaisses/i,
    /tiraille dans la journée/i, /manquer de douceur/i,
    // tiraillements
    /tiraille occasionnellement/i, /tiraille tout le temps/i, /rugeuse/i, /pèle/i,
    // rougeurs
    /démangeaisons/i, /rougeurs occasionnelles/i, /couperose/i,
    // taches
    /exposition au soleil/i, /grossesse/i, /rouges ou violettes/i, /cicatrices/i,
    // rides
    /fines ridules/i, /rides d'expression/i, /rides visibles/i, /rides profondes/i, /prévention/i, /relâchement/i,
    // boutons
    /ensemble du visage/i, /mâchoire/i, /cycle menstruel/i,
    // réactions
    /jamais mal réagi/i, /allergies/i, /contour des yeux/i,
    // habitudes
    /cigarette électronique/i, /fumeurs/i,
    // textures
    /^Onctueuse/, /^Légère/, /^Gel crème/, /^Riche/,
    /sans effet gras/i, /sans effet de matière/i, /film hydratant/i, /film nourrissant/i,
  ];

  function highlightKeywords(s) {
    var ranges = [];
    OPTION_KEYWORDS.forEach(function (re) {
      var m = s.match(re);
      if (!m || m.index == null) return;
      var start = m.index, end = start + m[0].length;
      var overlaps = ranges.some(function (r) { return start < r[1] && end > r[0]; });
      if (!overlaps) ranges.push([start, end]);
    });
    if (!ranges.length) return esc(s);
    ranges.sort(function (a, b) { return a[0] - b[0]; });
    var out = '', pos = 0;
    ranges.forEach(function (r) {
      out += esc(s.slice(pos, r[0])) + '<b>' + esc(s.slice(r[0], r[1])) + '</b>';
      pos = r[1];
    });
    return out + esc(s.slice(pos));
  }

  function formatOption(option) {
    var s = String(option);
    var card = s.length > 45;
    // parenthèse finale → complément en petit gris (ex. « (masque de grossesse) »)
    var main = s, paren = '';
    var m = s.match(/^(.*?)\s*(\([^()]{8,}\))\s*$/);
    if (m) { main = m[1]; paren = m[2]; }
    var html = highlightKeywords(main) +
      (paren ? (card ? '<span class="cb-chip-rest">' + esc(paren) + '</span>' : ' ' + esc(paren)) : '');
    return { card: card, html: html };
  }

  function chipsFor(entry) {
    var q = entry.sub ? currentSubQuestion() : currentQuestion();
    if (!q) return '';
    var opts = q.answers || [];
    var anyCard = opts.some(function (a) { return formatOption(a.option).card; });
    return '<div class="cb-chips' + (anyCard ? ' cb-chips-stack' : '') + '">' + opts.map(function (a, i) {
      var f = formatOption(a.option);
      var sug = state.suggested[a.option] ? ' cb-suggested' : '';
      var badge = state.suggested[a.option] ? '<span class="cb-sug-badge">📸 vu sur votre photo</span>' : '';
      return '<button class="cb-chip' + (f.card || anyCard ? ' cb-chip-card' : '') + sug + '" onclick="LaboteConsultation.answer(' + i + ')">' + f.html + badge + '</button>';
    }).join('') + '</div>';
  }

  var MONTHS_FR = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin',
    'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];

  // Date de naissance : 3 menus, l'année d'abord — nos clientes ne doivent pas
  // remonter 70 ans dans un calendrier (feedback Robin 18/08).
  function dateSelects() {
    var currentYear = new Date().getFullYear();
    var years = '<option value="">Année</option>';
    for (var y = currentYear - 16; y >= 1920; y--) years += '<option value="' + y + '">' + y + '</option>';
    var months = '<option value="">Mois</option>';
    MONTHS_FR.forEach(function (m, i) { months += '<option value="' + (i + 1) + '">' + m + '</option>'; });
    var days = '<option value="">Jour</option>';
    for (var d = 1; d <= 31; d++) days += '<option value="' + d + '">' + d + '</option>';
    return '<div class="cb-inputrow cb-daterow">' +
      '<select class="cb-input cb-select" id="cb-date-year">' + years + '</select>' +
      '<select class="cb-input cb-select" id="cb-date-month">' + months + '</select>' +
      '<select class="cb-input cb-select" id="cb-date-day">' + days + '</select>' +
      '<button class="cb-chip cb-validate" onclick="LaboteConsultation.submitInput()">' + S.validateLabel + '</button>' +
      '</div>';
  }

  function inputFor(entry) {
    var q = entry.sub ? currentSubQuestion() : currentQuestion();
    if (!q) return '';
    var isDate = q.question.indexOf('date de naissance') !== -1;
    if (isDate) return dateSelects();
    var optional = q.type === 'optional-input';
    var placeholder = q.input_placeholder || '';
    return '<div class="cb-inputrow">' +
      '<input class="cb-input" id="cb-free-input" type="text" placeholder="' + esc(placeholder) + '"' + (q.inputlength ? ' maxlength="' + q.inputlength + '"' : '') + '>' +
      '<button class="cb-chip cb-validate" onclick="LaboteConsultation.submitInput()">' + S.validateLabel + '</button>' +
      (optional ? '<button class="cb-chip" onclick="LaboteConsultation.skipInput()">' + S.skipLabel + '</button>' : '') +
      '</div>' + (optional ? '<p class="cb-consent">' + S.optionalHint + '</p>' : '');
  }

  function readDateSelects() {
    var y = el('cb-date-year'), m = el('cb-date-month'), d = el('cb-date-day');
    if (!y || !y.value || !m.value || !d.value) return null;
    var pad = function (n) { return String(n).length < 2 ? '0' + n : String(n); };
    return y.value + '-' + pad(m.value) + '-' + pad(d.value);
  }

  // --- Prix : toujours celui de la variante réellement envoyée au panier ---
  function centsOf(variant) {
    if (!variant) return null;
    var p = variant.price;
    if (typeof p === 'number') return p;
    var f = parseFloat(p);
    return isNaN(f) ? null : Math.round(f * 100);
  }
  function productPriceCents(productKey, fragrance, texture) {
    var v = E.variantFor(productKey, fragrance, texture, CFG);
    var c = centsOf(v);
    if (c != null) return c;
    var p = E.getProduct(productKey, CFG);
    return p && typeof p.price === 'number' ? p.price : 0;
  }
  function euros(cents) {
    return (cents % 100 ? (cents / 100).toFixed(2).replace('.', ',') : String(cents / 100)) + ' €';
  }

  function actifCard(name, description) {
    var img = actifImg(name);
    return '<div class="cb-acard">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
      '<div class="cb-acard-body"><div class="cb-acard-t">' + esc(name) + '</div>' +
      (description ? '<div class="cb-acard-d">' + esc(description) + '</div>' : '') +
      '</div><span class="cb-added">Ajouté ✓</span></div>';
  }

  // --- Bilan beauté personnalisé (fin de parcours) ---
  // Construit uniquement à partir des textes réels du quiz (content des réponses) :
  // profil de peau, priorités, rôle de chaque actif. Aucun claim inventé.
  function bilanHtml() {
    var product = state.product;
    if (!product) return '';
    // 1. profil de peau — texte exact de la réponse type de peau (pattern prod « Vous avez la peau … »)
    var skinRec = state.collected.find(function (r) { return r.qid === 'Yqik23N'; });
    var skinText = '';
    if (skinRec) {
      var byProd = (skinRec.content || {})[product] || {};
      var firstKey = Object.keys(byProd)[0];
      skinText = firstKey ? byProd[firstKey] : '';
    }
    // 2. priorités — les préoccupations choisies, avec leur précision
    var parents = state.collected.filter(function (r) {
      return r.group === 'concerns' && !r.parentOption && r.option !== 'Aucune préoccupation de peau';
    });
    var subs = state.collected.filter(function (r) { return r.group === 'concerns' && r.parentOption; });
    var priorities = parents.map(function (pr) {
      var sub = subs.find(function (s) { return s.parentOption === pr.option; });
      return { label: pr.option, detail: sub ? sub.option : null };
    });
    // 3. formule — rôle de chaque actif (textes content exacts, complets)
    var info = E.ingredientsInfo(state.collected, product);

    var html = '<div class="cb-bilan">' +
      '<div class="cb-bilan-head">Votre bilan beauté personnalisé</div>' +
      '<div class="cb-bilan-sub">' + esc(E.PRODUCT_LABELS_FR[product] || '') + ' sur-mesure · composée d\'après vos réponses</div>';
    if (skinText) {
      html += '<div class="cb-bilan-sec"><h4>Votre profil de peau</h4><p>Vous avez la peau ' + esc(skinText) + '</p></div>';
    }
    if (priorities.length) {
      html += '<div class="cb-bilan-sec"><h4>Vos priorités</h4><ol>' + priorities.map(function (pr) {
        return '<li><b>' + esc(pr.label) + '</b>' + (pr.detail ? '<span class="cb-bilan-detail">' + esc(pr.detail) + '</span>' : '') + '</li>';
      }).join('') + '</ol></div>';
    }
    if (info.length) {
      // regroupe les actifs qui partagent la même explication (ex. trio anti-rides)
      var actifGroups = [];
      info.forEach(function (i) {
        var g = actifGroups.find(function (x) { return x.description === i.description && x.from === i.from; });
        if (g) g.names.push(i.ingredient);
        else actifGroups.push({ names: [i.ingredient], description: i.description, from: i.from });
      });
      html += '<div class="cb-bilan-sec"><h4>Votre formule : le rôle de chaque actif</h4>' + actifGroups.map(function (g) {
        var img = actifImg(g.names[0]);
        return '<div class="cb-bilan-actif">' + (img ? '<img src="' + img + '" alt="">' : '') +
          '<div><b>' + esc(g.names.join(' + ')) + '</b> <span class="cb-bilan-from">parce que vous m\'avez indiqué « ' + esc(reasonLabel(g.from)) + ' »</span>' +
          (g.description ? '<p>' + esc(g.description) + '</p>' : '') + '</div></div>';
      }).join('') + '</div>';
    }
    html += '<p class="cb-bilan-close">' + esc(state.resultText || '') + '</p>' +
      '<p class="cb-bilan-expert">🧑‍🔬 Avant fabrication, votre formule est contrôlée et affinée par nos experts du laboratoire parisien.</p>' +
      '</div>';
    return html;
  }

  function captureEnabled() {
    // pas de capture pour une cliente déjà identifiée (l'offre bienvenue vise les nouveaux contacts)
    return !!(CFG.klaviyoListId && CFG.klaviyoCompanyId) && !(window.customer && window.customer.email) && !state.captured;
  }

  function captureBlock() {
    if (!captureEnabled()) return '';
    return '<div class="cb-inflow"><div class="cb-capture" id="cb-capture">' +
      '<h3>🤍 Votre offre de bienvenue vous attend</h3>' +
      '<input class="cb-input" id="cb-capture-firstname" type="text" placeholder="Votre prénom" style="margin-bottom:8px;">' +
      '<input class="cb-input" id="cb-capture-email" type="email" placeholder="Votre e-mail">' +
      '<div id="cb-capture-error" class="cb-small" style="color:#a3512e; display:none;">Cet e-mail ne semble pas valide.</div>' +
      '<button class="cb-cta" onclick="LaboteConsultation.submitCapture()">Recevoir ma formule et mon offre</button>' +
      '<p class="cb-small">En validant, vous acceptez de recevoir les offres et actualités Laboté par email, conformément à notre <a href="/pages/politique-de-confidentialite" target="_blank" rel="noopener">politique de confidentialité</a>. 🔒 Vos réponses restent chez Laboté.</p>' +
      '</div></div>';
  }

  async function submitCapture() {
    var emailInput = el('cb-capture-email');
    var firstInput = el('cb-capture-firstname');
    var errorBox = el('cb-capture-error');
    var email = emailInput ? emailInput.value.trim() : '';
    var first = firstInput ? firstInput.value.trim() : '';
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
      if (errorBox) errorBox.style.display = 'block';
      return;
    }
    if (errorBox) errorBox.style.display = 'none';
    state.email = email;
    if (first) state.firstName = first;
    var wrap = el('cb-capture');
    if (wrap) wrap.innerHTML = '<h3>🤍 Un instant…</h3>';
    var ok = await E.subscribeWelcome(email, first, CFG.klaviyoListId, CFG.klaviyoCompanyId);
    state.captured = true;
    E.track('Form Submission Completed', E.buildKlaviyoProps(state));
    E.identify(Object.assign({ $email: email }, first ? { $first_name: first } : {}));
    maybePostWorker(email);
    state.transcript = state.transcript.filter(function (e) { return e.t !== 'capture'; });
    renderAll();
    say(ok
      ? 'C\'est tout bon ' + (first ? esc(first) + ' ' : '') + '🤍 Votre offre de bienvenue et le détail de votre formule arrivent dans votre boîte mail.'
      : 'C\'est noté 🤍 Si l\'email tarde, pensez à vérifier vos courriers indésirables.');
  }


  // --- Rendu V2 : question ouverte, produits catalogue, routine --------------
  // Libellés courts des préoccupations pour l'écran d'accueil (l'option enregistrée
  // reste le libellé exact du questionnaire — seul l'affichage est raccourci)
  var CONCERN_SHORT = {
    'Inconfort et tiraillements (deshydratation et sécheresse)': 'Tiraillements, sécheresse',
    'Plaques d\'irritation (dont eczéma, psoriasis, dermatite seborrhéique)': 'Plaques d\'irritation',
    'Rides / Ridules (même en prévention)': 'Rides, ridules',
    'Boutons / Mycrokystes': 'Boutons, microkystes',
    'Aucune préoccupation de peau': 'Aucune en particulier',
  };
  function openInput() {
    // Écrire ou choisir, au choix de la cliente — le tout doit tenir sur un écran.
    var q = E.findQuestion(CONCERN_MAIN_QID);
    var chips = (q && q.answers || []).map(function (a) {
      return '<button class="cb-chip cb-chip-s" onclick="LaboteConsultation.chooseConcern(' + jsArg(a.option) + ')">' +
        esc(CONCERN_SHORT[a.option] || a.option) + '</button>';
    }).join('');
    return '<div class="cb-open">' +
      '<div class="cb-open-row"><input id="cb-open-input" class="cb-open-ta" type="text" placeholder="' + esc(S.openPlaceholder) + '" ' +
      'onkeydown="if(event.key===\'Enter\'){event.preventDefault();LaboteConsultation.submitOpenConcern();}">' +
      '<button class="cb-chip cb-validate" onclick="LaboteConsultation.submitOpenConcern()">' + S.validateLabel + '</button></div>' +
      '<div class="cb-chips cb-open-chips"><span class="cb-openhint">' + S.openHint + '</span>' + chips + '</div></div>';
  }

  function concernConfirmBlock(option) {
    return '<div class="cb-chips">' +
      '<button class="cb-chip cb-validate" onclick="LaboteConsultation.chooseConcern(' + jsArg(option) + ')">Oui, c\u2019est cela</button>' +
      '<button class="cb-chip" onclick="LaboteConsultation.rejectConcern()">' + S.openOther + '</button></div>';
  }

  function concernChoiceBlock(options) {
    return '<div class="cb-chips">' + options.map(function (o) {
      return '<button class="cb-chip" onclick="LaboteConsultation.chooseConcern(' + jsArg(o) + ')">' +
        highlightKeywords(esc(shortOption(o, 80))) + '</button>';
    }).join('') +
      '<button class="cb-chip" onclick="LaboteConsultation.rejectConcern()">' + S.openOther + '</button></div>';
  }

  // Confirmation d'une réponse comprise à partir du texte libre
  function answerConfirmBlock(entry) {
    return '<div class="cb-chips">' +
      '<button class="cb-chip cb-validate" onclick="LaboteConsultation.confirmFree(' +
      jsArg(entry.target) + ',' + jsArg(entry.qid || '') + ',' + jsArg(entry.option) + ')">' +
      highlightKeywords(esc(shortOption(entry.option, 80))) + '</button>' +
      '<button class="cb-chip" onclick="LaboteConsultation.declineFree()">Non, pas tout à fait</button></div>';
  }

  // Échappement pour un argument de chaîne dans un onclick inline
  function jsArg(v) {
    return "'" + String(v).replace(/\\/g, '\\\\').replace(/'/g, "\\'").replace(/"/g, '&quot;') + "'";
  }

  function recoCard(pr, stepLabel) {
    var img = pr.image ? '<img src="' + pr.image + '?width=160" alt="">' : '';
    var added = !!state.routineCart[pr.handle];
    var btn = '<button class="cb-pcard-add' + (added ? ' cb-added' : '') + '"' +
      (added ? ' disabled' : ' onclick="LaboteConsultation.addRecoToCart(' + jsArg(pr.handle) + ')"') + '>' +
      (added ? '✓ Ajouté' : 'Ajouter · ' + euros(Math.round(pr.price * 100))) + '</button>';
    return '<div class="cb-pcard">' + img +
      '<div class="cb-pcard-b">' +
      (stepLabel ? '<span class="cb-pcard-step">' + esc(stepLabel) + '</span>' : '') +
      '<span class="cb-pcard-t">' + esc(pr.title) + '</span>' +
      '<span class="cb-pcard-w">' + esc(pr.reason) + '</span>' + btn + '</div></div>';
  }

  function routineBlock() {
    var reco = state.routine;
    if (!reco || !reco.steps.length) return '';
    var html = '<div class="cb-routine">';
    reco.steps.forEach(function (st) {
      html += '<div class="cb-rstep"><div class="cb-rstep-h"><i>' + st.order + '</i>' + esc(st.label) + '</div>';
      st.products.forEach(function (pr) { html += recoCard(pr, null); });
      html += '</div>';
    });
    var reste = reco.steps.reduce(function (acc, st) {
      return acc.concat(st.products.filter(function (pr) { return !state.routineCart[pr.handle]; }));
    }, []);
    var total = reste.reduce(function (t, pr) { return t + (Number(pr.price) || 0); }, 0);
    if (reste.length > 1) {
      html += '<button class="cb-cta" onclick="LaboteConsultation.addRecoToCart(\'all\')">' +
        'Ajouter la routine complète · ' + euros(Math.round(total * 100)) + '</button>';
    }
    return html + '</div>';
  }

  function surMesureOfferBlock() {
    return '<div class="cb-chips">' +
      '<button class="cb-chip cb-validate" onclick="LaboteConsultation.acceptSurMesure()">' + S.surmesureYes + '</button>' +
      '<button class="cb-chip" onclick="LaboteConsultation.declineSurMesure()">' + S.surmesureNo + '</button></div>';
  }

  // Champ de saisie permanent — la cliente peut écrire à tout moment (plafonné)
  function renderComposer() {
    var box = el('cb-composer');
    if (!box) return;
    // La question ouverte d'accueil a déjà son champ : pas deux zones de saisie.
    if (state.transcript.some(function (e) { return e.t === 'open-input'; })) { box.innerHTML = ''; return; }
    var left = freeLeft();
    if (!left) {
      box.innerHTML = '<p class="cb-composer-off">' + S.freeLimit + '</p>';
      return;
    }
    box.innerHTML =
      '<div class="cb-composer-row">' +
      '<input id="cb-free-msg" class="cb-composer-in" type="text" placeholder="Écrivez-moi…" ' +
      'onkeydown="if(event.key===\'Enter\'){event.preventDefault();LaboteConsultation.submitFree();}">' +
      '<button class="cb-composer-btn" onclick="LaboteConsultation.submitFree()" aria-label="Envoyer">→</button>' +
      '</div><p class="cb-composer-left">' + left + ' message' + (left > 1 ? 's' : '') + ' restant' + (left > 1 ? 's' : '') + '</p>';
  }

  function renderEntry(entry) {
    switch (entry.t) {
      case 'expert': return bubbleExpert(entry.html);
      case 'user': return bubbleUser(entry.html);
      case 'typing': return bubbleTyping();
      case 'product-cards': return productCards();
      case 'open-input': return openInput();
      case 'concern-confirm': return concernConfirmBlock(entry.option);
      case 'concern-choice': return concernChoiceBlock(entry.options);
      case 'answer-confirm': return answerConfirmBlock(entry);
      case 'routine': return '<div class="cb-inflow">' + routineBlock() + '</div>';
      case 'pcard': return recoCardByHandle(entry.handle, entry.step);
      case 'surmesure-offer': return surMesureOfferBlock();
      case 'chips': return chipsFor(entry);
      case 'input': return inputFor(entry);
      case 'acard': return '<div class="cb-inflow">' + actifCard(entry.name, entry.description) + '</div>';
      case 'bilan': return '<div class="cb-inflow">' + bilanHtml() + '</div>';
      case 'capture': return captureBlock();
      case 'crosssell': return '<div class="cb-chips">' +
        '<button class="cb-chip cb-validate" onclick="LaboteConsultation.startCrossSell(\'' + entry.product + '\')">' + S.crossSellYes + '</button>' +
        '<button class="cb-chip" onclick="LaboteConsultation.declineCrossSell()">' + S.crossSellNo + '</button></div>';
      case 'photo-offer': return '<div class="cb-chips">' +
        '<button class="cb-chip cb-validate" onclick="LaboteConsultation.choosePhoto()">📸 Choisir une photo</button>' +
        '<button class="cb-chip" onclick="LaboteConsultation.declinePhoto()">💬 Je préfère répondre</button>' +
        '</div><p class="cb-consent">' + S.photoConsent + '</p>';
      case 'photo-retry': return '<div class="cb-chips">' +
        '<button class="cb-chip cb-validate" onclick="LaboteConsultation.choosePhoto()">📸 Reprendre une photo</button>' +
        '<button class="cb-chip" onclick="LaboteConsultation.declinePhoto()">💬 Répondre aux questions</button></div>';
      case 'photo-confirm': return '<div class="cb-chips">' +
        '<button class="cb-chip cb-validate" onclick="LaboteConsultation.confirmPhoto(true)">Oui, exactement ✓</button>' +
        '<button class="cb-chip" onclick="LaboteConsultation.confirmPhoto(false)">Pas tout à fait, je précise</button></div>';
    }
    return '';
  }

  function recoCardByHandle(handle, stepLabel) {
    var pr = findRecoProduct(handle);
    return pr ? '<div class="cb-inflow">' + recoCard(pr, stepLabel) + '</div>' : '';
  }

  function renderThread() {
    var thread = el('cb-thread');
    if (!thread) return;
    thread.innerHTML = state.transcript.map(renderEntry).join('');
    var scroller = el('cb-scroll') || thread;
    try { scroller.scrollTop = scroller.scrollHeight; } catch (e) {}
  }

  function shortOption(option, max) {
    var s = String(option || '');
    max = max || 46;
    return s.length > max ? s.slice(0, max - 1).replace(/[,\s]+\S*$/, '') + '…' : s;
  }

  // Accroche courte d'une réponse (avant la première coupure naturelle) — pour les
  // rappels compacts (« pourquoi » d'un actif, profil) : jamais de phrase tronquée à l'ellipse.
  function reasonLabel(option) {
    var s = String(option || '');
    if (s.length <= 48) return s;
    var best = -1;
    [', ', '. ', ' (', ' et ', ' pour '].forEach(function (sep) {
      var i = s.indexOf(sep);
      if (i >= 10 && (best === -1 || i < best)) best = i;
    });
    if (best !== -1 && best <= 55) return s.slice(0, best);
    return shortOption(s, 48);
  }

  function renderProfile() {
    var panel = el('cb-profile-body');
    if (!panel) return;
    var a = answeredQids();
    var qs = diagnosticQuestions();
    var total = qs.length;
    // une question compte comme traitée si répondue, sautée (« Aucune préoccupation »)
    // ou renseignée via un input (date) — sinon la jauge plafonne
    var done = qs.filter(function (q) {
      return a[qKey(q)] || state.skippedQids[qKey(q)] || isInputAnswered(q);
    }).length;
    var termine = state.phase === 'routine' || state.phase === 'surmesure' || state.phase === 'done';
    var pct = termine ? 100 : Math.min(100, Math.round(done / Math.max(total, 1) * 100));
    var byGroup = {};
    state.collected.forEach(function (r) {
      if (!byGroup[r.group]) byGroup[r.group] = [];
      byGroup[r.group].push(r);
    });
    var rows = '';
    var pLabel = state.product ? E.PRODUCT_LABELS_FR[state.product] : null;
    var doneLabels = state.doneProducts.map(function (d) { return E.PRODUCT_LABELS_FR[d.product]; });
    if (doneLabels.length) pLabel = doneLabels.concat(pLabel ? [pLabel] : []).join(' + ');
    if (pLabel) rows += '<div class="cb-field"><span>Mon soin sur-mesure</span><b>' + esc(pLabel) + '</b></div>';
    ['skin_type', 'concerns', 'moment_of_life', 'reactions', 'habits'].forEach(function (g) {
      var recs = byGroup[g] || [];
      var label = GROUP_LABELS[g];
      if (!recs.length) { rows += '<div class="cb-field"><span>' + label + '</span><span class="cb-empty">à venir…</span></div>'; return; }
      var val = recs.map(function (r) { return reasonLabel(r.option); }).join(' · ');
      rows += '<div class="cb-field"><span>' + label + '</span><b>' + esc(val) + '</b></div>';
    });
    if (state.fragrance || state.texture) {
      var perso = [state.fragrance, state.texture ? state.texture.split(' ')[0] : null].filter(Boolean).join(' · ');
      rows += '<div class="cb-field"><span>' + GROUP_LABELS.customization + '</span><b>' + esc(perso) + '</b></div>';
    }
    var photoSlot = '';
    if (state.photoThumb) {
      photoSlot = '<div class="cb-field-title">Ma photo</div><img class="cb-photo-thumb" src="' + state.photoThumb + '" alt="Votre photo (non conservée)">';
    } else if (CFG.visionEnabled && state.phase === 'diagnostic' && state.photoOffered && !state.photoResult) {
      photoSlot = '<button class="cb-photo-add" onclick="LaboteConsultation.choosePhoto()">📸 Montrer ma peau (facultatif)</button>';
    }
    panel.innerHTML =
      '<div class="cb-gauge"><div style="width:' + pct + '%"></div></div>' +
      '<div class="cb-gauge-label">Profil complété à ' + pct + ' %</div>' + rows + photoSlot;
  }

  function formulaBlock(product, fragrance, texture, isCurrent) {
    var p = E.getProduct(product, CFG);
    if (!p) return '';
    var info = E.ingredientsInfo(state.collected, product);
    var rows = info.map(function (i) {
      var img = actifImg(i.ingredient);
      return '<div class="cb-fitem">' + (img ? '<img src="' + img + '" alt="">' : '') +
        '<div class="cb-fitem-b"><span class="cb-fitem-n">' + esc(i.ingredient) + '</span>' +
        '<span class="cb-fitem-w">' + esc(reasonLabel(i.from)) + '</span></div></div>';
    }).join('');
    var perso = '';
    if (product === 'daily_cream' || product === 'night_cream') {
      perso = '<div class="cb-field"><span>Parfum</span>' + (fragrance ? '<b>' + esc(fragrance) + '</b>' : '<span class="cb-empty">à choisir</span>') + '</div>' +
        '<div class="cb-field"><span>Texture</span>' + (texture ? '<b>' + esc(texture.split(' ')[0]) + '</b>' : '<span class="cb-empty">à choisir</span>') + '</div>';
    }
    return '<div class="cb-formula' + (isCurrent ? '' : ' cb-formula-done') + '">' +
      '<div class="cb-fhead">' + (p.image ? '<img src="' + p.image + '" alt="">' : '') +
      '<div><div class="cb-fhead-t">' + esc(p.title) + '</div>' +
      '<div class="cb-fhead-d">' + (product === 'serum' ? '30 ml · sans parfum, texture fluide' : 'Pot 50 ml · formulée à la demande') + '</div></div></div>' +
      (rows ? '<div class="cb-ftitle">Vos actifs</div>' + rows : '') + perso + '</div>';
  }

  // Résumé de la routine catalogue dans le panneau « Ma sélection »
  function routineSummary() {
    var reco = state.routine;
    if (!reco || !reco.steps.length) return { html: '', count: 0 };
    var count = 0, rows = '';
    reco.steps.forEach(function (st) {
      st.products.forEach(function (pr) {
        count++;
        var img = pr.image ? '<img src="' + pr.image + '?width=80" alt="">' : '';
        rows += '<div class="cb-fitem">' + img + '<div class="cb-fitem-b">' +
          '<span class="cb-fitem-n">' + esc(pr.title) + '</span>' +
          '<span class="cb-fitem-w">' + esc(st.label) + ' · ' + euros(Math.round(pr.price * 100)) + '</span>' +
          '</div></div>';
      });
    });
    var reste = reco.steps.reduce(function (acc, st) {
      return acc.concat(st.products.filter(function (pr) { return !state.routineCart[pr.handle]; }));
    }, []);
    var total = reste.reduce(function (t, pr) { return t + (Number(pr.price) || 0); }, 0);
    var cta = reste.length
      ? '<button class="cb-cta" onclick="LaboteConsultation.addRecoToCart(\'all\')">Ajouter ma routine · ' + euros(Math.round(total * 100)) + '</button>'
      : '<div class="cb-experts">✓ Votre routine est dans le panier</div>';
    return {
      html: '<div class="cb-formula"><div class="cb-ftitle">Votre routine</div>' + rows + cta + '</div>',
      count: count,
    };
  }

  function renderSelection() {
    var panel = el('cb-selection-body');
    if (!panel) return;
    var routine = routineSummary();
    var badge = el('cb-tab-badge');
    var count = routine.count + state.doneProducts.length + (state.product ? 1 : 0);
    if (badge) { badge.textContent = count; badge.style.display = count ? 'flex' : 'none'; }
    if (!count) {
      panel.innerHTML = '<p class="cb-empty" style="padding:8px 0;">Votre sélection se compose au fil de notre conversation ✨</p>';
      return;
    }
    var html = routine.html;
    if (!state.product && !state.doneProducts.length) {
      panel.innerHTML = html;
      return;
    }
    state.doneProducts.forEach(function (d) { html += formulaBlock(d.product, d.fragrance, d.texture, false); });
    if (state.product) html += formulaBlock(state.product, state.fragrance, state.texture, true);
    // prix de la variante réellement ajoutée au panier (évolue avec parfum/texture)
    var totalCents = 0;
    var all = state.doneProducts.concat(state.product
      ? [{ product: state.product, fragrance: state.fragrance, texture: state.texture }] : []);
    all.forEach(function (d) {
      totalCents += productPriceCents(d.product, d.fragrance, d.texture);
    });
    html += '<div class="cb-total"><span>Total</span><b>' + euros(totalCents) + '</b></div>';
    var readyCount = state.doneProducts.length + (state.phase === 'done' && state.product ? 1 : 0);
    if (readyCount > 0) {
      var ctaLabel = readyCount > 1 ? 'Faire fabriquer mes formules' : 'Faire fabriquer ma formule';
      html += '<button class="cb-cta" id="cb-cart-cta" onclick="LaboteConsultation.addSelectionToCart()">' + ctaLabel + ' · ' + euros(totalCents) + '</button>';
    }
    html += '<div class="cb-experts">🧑‍🔬 Formule vérifiée et affinée par nos experts avant fabrication</div>';
    panel.innerHTML = html;
  }

  function renderAll() { renderThread(); renderProfile(); renderSelection(); renderComposer(); }

  // --- File de messages avec effet de frappe ---
  var queue = Promise.resolve();
  function say(html) {
    queue = queue.then(function () {
      return new Promise(function (resolve) {
        if (instant) { state.transcript.push({ t: 'expert', html: html }); renderAll(); resolve(); return; }
        state.transcript.push({ t: 'typing' });
        renderThread();
        setTimeout(function () {
          state.transcript.pop();
          state.transcript.push({ t: 'expert', html: html });
          renderAll();
          resolve();
        }, Math.min(500 + html.length * 5, 1400));
      });
    });
    return queue;
  }
  function push(entry) { queue = queue.then(function () { state.transcript.push(entry); renderAll(); }); return queue; }

  // --- Persistance (journal d'actions rejoué en mode instantané) ---
  function saveSession() {
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ actions: state.actions, ts: Date.now() })); } catch (e) {}
  }
  function logAction(a) { state.actions.push(a); saveSession(); }

  function removeInputs() {
    queue = queue.then(function () {
      state.transcript = state.transcript.filter(function (e) {
        return ['chips', 'product-cards', 'input', 'crosssell', 'photo-offer', 'photo-retry', 'photo-confirm',
          'open-input', 'concern-confirm', 'concern-choice', 'answer-confirm', 'surmesure-offer'].indexOf(e.t) === -1;
      });
    });
  }

  // --- Photo (P2) : upload → 1024px JPEG → Edge Function → boucle de confirmation ---
  function choosePhoto() {
    var input = el('cb-photo-input');
    if (input) input.click();
  }

  function declinePhoto(fromReplay) {
    if (!fromReplay) { logAction({ a: 'photoDecline' }); E.track('Consultation Photo Declined', {}); }
    removeInputs();
    advance();
  }

  function downscale(file) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      var url = URL.createObjectURL(file);
      img.onload = function () {
        var max = 1024;
        var scale = Math.min(1, max / Math.max(img.width, img.height));
        var canvas = document.createElement('canvas');
        canvas.width = Math.round(img.width * scale);
        canvas.height = Math.round(img.height * scale);
        canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
        resolve({ dataUrl: canvas.toDataURL('image/jpeg', 0.85), thumbUrl: url });
      };
      img.onerror = reject;
      img.src = url;
    });
  }

  async function onPhotoFile(file) {
    if (!file) return;
    removeInputs();
    push({ t: 'user', html: '📸 Ma photo' });
    E.track('Consultation Photo Uploaded', {});
    say(S.photoLooking);
    var result = null;
    try {
      var down = await downscale(file);
      state.photoThumb = down.thumbUrl; // mémoire navigateur uniquement, jamais persisté
      renderProfile();
      var controller = new AbortController();
      var timer = setTimeout(function () { controller.abort(); }, 12000);
      var resp = await fetch(VISION_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + VISION_KEY },
        body: JSON.stringify({ image: down.dataUrl }),
        signal: controller.signal,
      });
      clearTimeout(timer);
      if (resp.ok) result = await resp.json();
    } catch (e) { /* silencieux : bascule questions */ }
    handleVision(result);
  }

  function handleVision(res) {
    removeInputs();
    if (!res || res.error || !res.exploitable) {
      if (res && res.exploitable === false) E.track('Consultation Photo Analyzed', { exploitable: false });
      say(res && res.exploitable === false ? S.photoUnusable : S.photoFail);
      advance();
      return;
    }
    E.track('Consultation Photo Analyzed', {
      exploitable: true, confiance: res.confiance, cadrage: res.cadrage,
      nature: res.nature_apparente, preoccupations: res.preoccupations_visibles,
    });
    if (res.confiance === 'faible' && !state.photoRetryUsed) {
      state.photoRetryUsed = true; // une seule relance, jamais plus
      say(S.photoCloser);
      push({ t: 'photo-retry' });
      return;
    }
    var hasNature = res.nature_apparente && res.nature_apparente !== 'indeterminee';
    var concerns = res.preoccupations_visibles || [];
    if (!hasNature && !concerns.length) { say(S.photoUnusable); advance(); return; }
    state.photoResult = res;
    if (res.message_observation) say(esc(res.message_observation));
    var parts = [];
    if (hasNature) parts.push('votre peau semble <b>' + NATURE_LABELS[res.nature_apparente] + '</b>');
    if (concerns.length) parts.push('je remarque plutôt <b>' + concerns.map(esc).join('</b> et <b>') + '</b>');
    say('Dites-moi si je vois juste : ' + parts.join(', et ') + ' ?');
    push({ t: 'photo-confirm' });
  }

  function confirmPhoto(accepted, fromReplay) {
    var res = state.photoResult;
    if (!res) return;
    if (!fromReplay) logAction({ a: 'photoConfirm', ok: !!accepted, res: res });
    removeInputs();
    var natureOpts = NATURE_SKIN_OPTIONS[res.nature_apparente] || [];
    var skinQ = E.findQuestion('Yqik23N');
    if (accepted) {
      state.inputMethod = 'photo';
      push({ t: 'user', html: 'Oui, exactement ✓' });
      // la nature suggère les options du type de peau (la cliente choisit toujours elle-même)
      natureOpts.forEach(function (i) {
        if (skinQ && skinQ.answers[i]) state.suggested[skinQ.answers[i].option] = true;
      });
      // les préoccupations confirmées se répondent automatiquement quand leur question arrive
      state.autoConcerns = (res.preoccupations_visibles || []).slice();
    } else {
      state.inputMethod = 'mixte';
      push({ t: 'user', html: 'Pas tout à fait, je précise' });
      // tout devient simple suggestion visuelle, rien n'est décidé
      natureOpts.forEach(function (i) {
        if (skinQ && skinQ.answers[i]) state.suggested[skinQ.answers[i].option] = true;
      });
      (res.preoccupations_visibles || []).forEach(function (label) { state.suggested[label] = true; });
    }
    advance();
  }

  // --- Navigation dans le questionnaire ---
  function currentQuestion() {
    var qs = askQuestions();
    return (state.qIndex >= 0 && state.qIndex < qs.length) ? qs[state.qIndex] : null;
  }
  function currentSubQuestion() { return state.pendingSubs.length ? state.pendingSubs[0] : null; }

  var lastGroup = null;
  function presentQuestion() {
    var sub = currentSubQuestion();
    var q = sub || currentQuestion();
    if (!q) {
      if (state.phase === 'surmesure') finishProduct();
      else finishDiagnostic();
      return;
    }
    // préoccupations confirmées sur photo → réponse automatique (la cliente a validé)
    if (!sub && CONCERN_QIDS.indexOf(q.question_id) !== -1 && state.autoConcerns.length) {
      var label = state.autoConcerns.shift();
      var idx = (q.answers || []).findIndex(function (a) { return a.option === label; });
      if (idx !== -1) { answer(idx, 'auto'); return; }
    }
    if (!sub && q.group && q.group !== lastGroup) {
      lastGroup = q.group;
      if (S.groupIntro[q.group]) say(S.groupIntro[q.group]);
    }
    // Conseil sans parfum juste avant la question parfum
    if (!sub && q.question_id === 'perfume') {
      var advice = E.fragranceAdvice(state.collected);
      if (advice.length) say(S.noFragranceAdvice[advice[0]]);
    }
    say('<b>' + esc(q.question) + '</b>' + (q.subtitle ? '<br><span class="cb-sub">' + esc(q.subtitle) + '</span>' : ''));
    if (q.type === 'input' || q.type === 'optional-input') push({ t: 'input', sub: !!sub });
    else push({ t: 'chips', sub: !!sub });
  }

  function advance() {
    if (state.pendingSubs.length) { presentQuestion(); return; }
    var qs = askQuestions();
    var a = answeredQids();
    do {
      state.qIndex++;
      var q = qs[state.qIndex];
      if (state.skipCount > 0 && state.qIndex < qs.length) {
        state.skipCount--;
        // le saut se propage au cross-sell (« Aucune préoccupation » vaut pour tous les produits)
        if (q) state.skippedQids[qKey(q)] = true;
        continue;
      }
      // cross-sell : ne repose ni les questions déjà répondues ni celles déjà sautées
      if (q && (a[qKey(q)] || state.skippedQids[qKey(q)])) continue;
      if (q && isInputAnswered(q)) continue;
      break;
    } while (state.qIndex < qs.length);
    presentQuestion();
  }

  function isInputAnswered(q) {
    if (q.type === 'input') return !!state.dateOfBirth;
    if (q.type === 'optional-input') {
      var map = { name_on_box: 'nameOnBox', note: 'note', additional_information: 'additionalInformation' };
      var key = map[q.name];
      return key ? state['_asked_' + key] === true : false;
    }
    return false;
  }

  // --- Actions utilisateur ---
  function chooseProduct(productKey, fromReplay) {
    if (!fromReplay) logAction({ a: 'product', p: productKey });
    if (!state.startTracked) {
      state.startTracked = true;
      E.track('Consultation Started', { product: productKey });
    }
    removeInputs();
    state.product = productKey;
    // Le diagnostic est déjà posé : il ne reste que la personnalisation du soin.
    state.phase = 'surmesure';
    state.qIndex = -1; state.pendingSubs = []; state.skipCount = 0;
    state.fragrance = null; state.texture = null;
    lastGroup = null;
    var label = E.PRODUCT_LABELS_FR[productKey];
    push({ t: 'user', html: 'Ma ' + esc(label) + ' sur-mesure' });
    advance();
  }

  // P2 : la photo est proposée une seule fois, au début du diagnostic.
  // visionEnabled (réglage de section) reste OFF tant que l'Edge Function n'est pas en ligne.
  function maybeOfferPhoto(fromReplay) {
    if (!CFG.visionEnabled || state.photoOffered) return false;
    state.photoOffered = true;
    if (!fromReplay) E.track('Consultation Photo Offered', {});
    say(S.photoOffer);
    push({ t: 'photo-offer' });
    return true;
  }

  function handleAnswerRecord(q, ansObj, parentOption) {
    var r = E.record(q, ansObj, parentOption);
    state.collected.push(r);
    // Pendant le diagnostic, aucun soin n'est encore choisi : on accuse réception
    // et on laisse la routine se recomposer dans « Ma sélection ». Les actifs et
    // leurs textes (claims validés du quiz) n'arrivent qu'au moment du sur-mesure.
    if (!state.product) { noteRoutineChange(ansObj.option); return; }
    // argumentation : actifs ajoutés pour le produit en cours
    var names = (ansObj[state.product] || []).map(E.normalizeName);
    if (names.length) {
      say(S.ackAdd.replace('{option}', esc(shortOption(ansObj.option, 60))));
      var byProduct = (ansObj.content || {})[state.product] || {};
      // les actifs qui partagent le même texte sont regroupés en une carte
      var groups = [];
      names.forEach(function (n) {
        var raw = byProduct[n];
        if (!raw) {
          var k = Object.keys(byProduct).find(function (key) { return E.normalizeName(key) === n; });
          raw = k ? byProduct[k] : '';
        }
        var g = groups.find(function (x) { return x.description === (raw || ''); });
        if (g) g.names.push(n); else groups.push({ names: [n], description: raw || '' });
      });
      groups.forEach(function (g) {
        // texte complet du quiz, jamais coupé (feedback Robin)
        push({ t: 'acard', name: g.names.join(' + '), description: g.description });
      });
    }
  }

  function answer(index, fromReplay) {
    var sub = currentSubQuestion();
    var q = sub || currentQuestion();
    if (!q || !(q.answers || [])[index]) return;
    if (!fromReplay) logAction({ a: 'answer', i: index });
    var ansObj = q.answers[index];
    removeInputs();
    push({ t: 'user', html: esc(ansObj.option) });

    if (sub) {
      state.pendingSubs.shift();
      handleAnswerRecord(q, ansObj, sub._parentOption);
    } else {
      // personnalisation : parfum / texture (pas d'actifs)
      if (q.question_id === 'perfume') { state.fragrance = ansObj.option; }
      else if (q.question_id === 'jourtexture' || q.question_id === 'nuittexture') {
        state.texture = E.textureKeyFromOption(ansObj.option);
      }
      handleAnswerRecord(q, ansObj, null);
      applySkip(q.question_id, ansObj.option);
      if (ansObj.has_sub_question && (ansObj.questions || []).length) {
        state.pendingSubs = ansObj.questions.map(function (sq) {
          var copy = Object.assign({}, sq);
          copy._parentOption = ansObj.option;
          return copy;
        });
      }
    }
    advance();
  }

  function submitInput(fromReplay, replayValue) {
    var sub = currentSubQuestion();
    var q = sub || currentQuestion();
    if (!q) return;
    var value = replayValue;
    if (!fromReplay) {
      var isDate = q.question.indexOf('date de naissance') !== -1;
      if (isDate) {
        value = readDateSelects();
        if (!value) return; // les 3 champs sont requis
      } else {
        var input = el('cb-free-input');
        value = input ? input.value.trim() : '';
      }
      if (q.type === 'input' && !value) return;
      logAction({ a: 'input', v: value });
    }
    removeInputs();
    storeInput(q, value);
    if (value) push({ t: 'user', html: esc(value) });
    advance();
  }

  function skipInput(fromReplay) {
    var q = currentSubQuestion() || currentQuestion();
    if (!q) return;
    if (!fromReplay) logAction({ a: 'skip' });
    removeInputs();
    storeInput(q, '');
    push({ t: 'user', html: S.skipLabel });
    advance();
  }

  function storeInput(q, value) {
    if (q.type === 'input') { state.dateOfBirth = value || state.dateOfBirth; return; }
    var map = { name_on_box: 'nameOnBox', note: 'note', additional_information: 'additionalInformation' };
    var key = map[q.name];
    if (key) { state[key] = value || ''; state['_asked_' + key] = true; }
  }


  // ==========================================================================
  //  V2 — question ouverte, routine catalogue, sur-mesure en fin de parcours
  // ==========================================================================

  // --- Question ouverte d'accueil ------------------------------------------
  function readFreeText(id) {
    var input = el(id || 'cb-open-input');
    return input ? String(input.value || '').trim() : '';
  }

  // Interprétation locale (aucun appel réseau) : on PROPOSE, la cliente confirme.
  function interpret(text) {
    if (!R) return [];
    return R.matchConcern(text).filter(function (m) { return m.option !== E.OPT.noConcern; });
  }

  function submitOpenConcern(fromReplay, replayValue) {
    var text = fromReplay ? replayValue : readFreeText('cb-open-input');
    if (!text) return;
    if (!fromReplay) logAction({ a: 'open', v: text });
    removeInputs();
    state.openAnswered = true;
    if (!state.startTracked) {
      state.startTracked = true;
      E.track('Consultation Started', { entry: 'open_question' });
    }
    push({ t: 'user', html: esc(text) });
    var matches = interpret(text);
    if (!matches.length) {
      say(S.openUnclear);
      startDiagnosticAt(CONCERN_MAIN_QID);
      return;
    }
    if (matches.length === 1) {
      say(S.openConfirm.replace('{label}', esc(shortOption(matches[0].option, 70))));
      push({ t: 'concern-confirm', option: matches[0].option });
      return;
    }
    say(S.openMulti);
    push({ t: 'concern-choice', options: matches.slice(0, 3).map(function (m) { return m.option; }) });
  }

  // Ouvre le questionnaire sur une question donnée (sans y répondre)
  function startDiagnosticAt(qid) {
    state.phase = 'diagnostic';
    var qs = askQuestions();
    var idx = qs.findIndex(function (q) { return qKey(q) === qid; });
    state.qIndex = idx === -1 ? -1 : idx;
    state.pendingSubs = [];
    lastGroup = 'concerns'; // pas d'intro de groupe : on est déjà dans la conversation
    if (idx === -1) { advance(); return; }
    presentQuestion();
  }

  // Enregistre une préoccupation choisie librement, puis déroule le questionnaire.
  function chooseConcern(option, fromReplay) {
    if (!fromReplay) logAction({ a: 'concern', v: option });
    removeInputs();
    state.openAnswered = true;
    if (!state.startTracked) {
      state.startTracked = true;
      E.track('Consultation Started', { entry: 'open_question' });
    }
    var q = E.findQuestion(CONCERN_MAIN_QID);
    var ansObj = (q.answers || []).find(function (a) { return a.option === option; });
    if (!ansObj) { startDiagnosticAt(CONCERN_MAIN_QID); return; }
    state.phase = 'diagnostic';
    push({ t: 'user', html: esc(shortOption(option, 80)) });
    handleAnswerRecord(q, ansObj, null);
    applySkip(q.question_id, ansObj.option);
    if (ansObj.has_sub_question && (ansObj.questions || []).length) {
      state.pendingSubs = ansObj.questions.map(function (sq) {
        var copy = Object.assign({}, sq);
        copy._parentOption = ansObj.option;
        return copy;
      });
    }
    state.qIndex = -1;    // le reste du questionnaire reprend son ordre naturel
    lastGroup = null;
    if (maybeOfferPhoto(fromReplay)) return;
    advance();
  }

  function rejectConcern(fromReplay) {
    if (!fromReplay) logAction({ a: 'concernNo' });
    removeInputs();
    push({ t: 'user', html: S.openOther });
    say(S.openUnclear);
    startDiagnosticAt(CONCERN_MAIN_QID);
  }

  // --- Routine catalogue ----------------------------------------------------
  function actifsSoFar() {
    // les actifs que la formule sur-mesure retiendrait aujourd'hui, tous soins
    // confondus : sert à relier la routine catalogue au sur-mesure.
    var res = E.computeResultIngredients(state.collected);
    var all = [];
    DIAG_PRODUCTS.forEach(function (pr) {
      (res[pr] || []).forEach(function (a) { if (all.indexOf(a) === -1) all.push(a); });
    });
    return all;
  }

  function computeRoutine() {
    if (!R) return null;
    state.routine = R.recommend(state.collected, { actifs: actifsSoFar() });
    return state.routine;
  }

  // Pendant le diagnostic : signale discrètement qu'un soin vient d'entrer dans la routine.
  function noteRoutineChange(option) {
    var before = state.routine;
    var after = computeRoutine();
    if (!after) { say(S.ackNoAdd); return; }
    var had = {};
    if (before) before.steps.forEach(function (st) { st.products.forEach(function (pr) { had[pr.handle] = true; }); });
    var nouveaux = [];
    after.steps.forEach(function (st) {
      st.products.forEach(function (pr) { if (!had[pr.handle]) nouveaux.push({ step: st, p: pr }); });
    });
    if (!before || !nouveaux.length) { say(S.ackNoAdd); return; }
    say(S.ackAdd.replace('{option}', esc(shortOption(option, 60))).replace('à votre formule', 'à votre routine'));
    nouveaux.slice(0, 2).forEach(function (n) {
      push({ t: 'pcard', handle: n.p.handle, step: n.step.label });
    });
  }

  function findRecoProduct(handle) {
    var found = null;
    ((state.routine && state.routine.steps) || []).forEach(function (st) {
      st.products.forEach(function (pr) { if (pr.handle === handle) found = pr; });
    });
    return found;
  }

  function finishDiagnostic() {
    if (state.phase === 'routine' || state.phase === 'surmesure' || state.phase === 'done') return;
    state.phase = 'routine';
    var reco = computeRoutine();
    E.track('Consultation Completed', {
      input_method: state.inputMethod,
      skin_code: E.skinCode(state.collected).skinType,
      routine_products: reco ? reco.steps.reduce(function (acc, st) {
        return acc.concat(st.products.map(function (pr) { return pr.handle; }));
      }, []) : [],
    });
    if (!reco || !reco.steps.length) { say(S.routineEmpty); }
    else {
      say(S.routineIntro);
      push({ t: 'routine' });
      if (reco.excluded.reasons.length) {
        say('Une précision : j’ai écarté certains soins — ' + esc(reco.excluded.reasons.join(', ')) + '.');
      }
      say(S.routineOutro);
    }
    maybeShowCapture();
    offerSurMesure();
  }

  function offerSurMesure() {
    if (state.surmesureOffered) return;
    state.surmesureOffered = true;
    say(S.surmesureOffer);
    push({ t: 'surmesure-offer' });
  }

  function acceptSurMesure(fromReplay) {
    if (!fromReplay) logAction({ a: 'sm' });
    removeInputs();
    push({ t: 'user', html: S.surmesureYes });
    say(S.surmesureWhich);
    push({ t: 'product-cards' });
  }

  function declineSurMesure(fromReplay) {
    if (!fromReplay) logAction({ a: 'smNo' });
    removeInputs();
    push({ t: 'user', html: S.surmesureNo });
    say(S.surmesureDeclined);
  }

  // --- Panier catalogue -----------------------------------------------------
  async function addRecoToCart(handle, fromReplay) {
    var items = [];
    if (handle === 'all') {
      ((state.routine && state.routine.steps) || []).forEach(function (st) {
        st.products.forEach(function (pr) { if (!state.routineCart[pr.handle]) items.push(pr); });
      });
    } else {
      var one = findRecoProduct(handle);
      if (one && !state.routineCart[handle]) items.push(one);
    }
    if (!items.length) return;
    if (!fromReplay) logAction({ a: 'reco', h: handle });
    var payload = items.map(function (pr) {
      return { id: pr.variant, quantity: 1, properties: { _consultation: 'routine', _raison: pr.reason } };
    });
    var data = null;
    try {
      var resp = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: payload, sections: 'cart-drawer,cart-icon-bubble' }),
      });
      if (!resp.ok) throw new Error('cart ' + resp.status);
      data = await resp.json();
      items.forEach(function (pr) { state.routineCart[pr.handle] = true; });
    } catch (e) { /* le rendu remettra le bouton à disposition */ }
    E.track('Consultation Routine Added to Cart', {
      source: 'catalogue',
      products: items.map(function (pr) { return pr.handle; }),
    });
    if (data) { refreshCartDrawer(data); say(S.routineAdded); }
    renderAll();
  }

  // --- Texte libre permanent (plafonné) -------------------------------------
  // La cliente peut écrire à tout moment. Son message est interprété vers une
  // réponse EXACTE du questionnaire, qu'elle confirme ensuite : le moteur et les
  // payloads envoyés au laboratoire restent ceux du quiz de prod.
  function freeLeft() { return Math.max(0, MAX_FREE_MESSAGES - state.freeCount); }

  // Question à laquelle le message peut répondre, et options exactes associées.
  function freeTarget() {
    var q = currentSubQuestion() || currentQuestion();
    if (q && (q.answers || []).length) {
      return { target: 'current', question: q, options: q.answers.map(function (a) { return a.option; }) };
    }
    // Hors question (routine, fin de parcours) : reste la possibilité d'ajouter
    // une préoccupation si un emplacement est libre.
    var libre = CONCERN_QIDS.filter(function (qid) {
      return !state.collected.some(function (r) { return r.qid === qid; }) && !state.skippedQids[qid];
    });
    if (!libre.length) return { target: 'none', question: null, options: [] };
    var cq = E.findQuestion(CONCERN_MAIN_QID);
    return {
      target: 'concern', qid: libre[0], question: cq,
      options: (cq.answers || []).map(function (a) { return a.option; }),
    };
  }

  // Repli local (aucun réseau) : le lexique de reco-rules.json.
  function localReply(text, ctx) {
    var matches = interpret(text);
    var known = {};
    state.collected.forEach(function (r) { known[r.option] = true; });
    var hit = matches.find(function (m) { return ctx.options.indexOf(m.option) !== -1 && !known[m.option]; });
    if (hit) return { message: S.freeAck, option: hit.option };
    if (matches.length && ctx.target === 'none') return { message: S.freeNoSlot, option: null };
    return { message: S.freeUnknown, option: null };
  }

  // Interprétation par l'experte (Edge Function Supabase, clé Anthropic en Vault).
  async function askExpert(text, ctx) {
    if (!CFG.chatEnabled) return null;
    try {
      var resp = await fetch(CHAT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + VISION_KEY },
        body: JSON.stringify({
          message: text,
          question: ctx.question ? ctx.question.question : '',
          options: ctx.options,
          profil: state.collected.map(function (r) { return r.option; }),
        }),
      });
      if (!resp.ok) return null;
      var data = await resp.json();
      if (!data || typeof data.message !== 'string' || !data.message) return null;
      return {
        message: esc(data.message),
        option: typeof data.option === 'string' && ctx.options.indexOf(data.option) !== -1 ? data.option : null,
        human: data.orienter_vers_humain === true,
      };
    } catch (e) { return null; }
  }

  async function submitFree(fromReplay, replayValue, replayReply) {
    var text = fromReplay ? replayValue : readFreeText('cb-free-msg');
    if (!text) return;
    if (!fromReplay && !freeLeft()) return;
    state.freeCount++;
    var box = el('cb-free-msg');
    if (box) box.value = '';
    // Si la question ouverte d'accueil attend encore une réponse, ce message EST cette réponse.
    if (!state.openAnswered) { submitOpenConcern(fromReplay, text); renderAll(); return; }

    removeInputs();
    push({ t: 'user', html: esc(text) });
    var ctx = freeTarget();
    var reply = fromReplay ? (replayReply || { message: S.freeAck, option: null })
      : (await askExpert(text, ctx)) || localReply(text, ctx);
    if (!fromReplay) logAction({ a: 'free', v: text, r: reply });

    say(reply.message);
    if (reply.option) {
      push({ t: 'answer-confirm', option: reply.option, target: ctx.target, qid: ctx.qid || null });
    } else if (!reply.human) {
      repeatCurrentQuestion();
    } else {
      repeatCurrentQuestion();
    }
    if (!freeLeft()) say(S.freeLimit);
    renderAll();
  }

  // Confirmation d'une réponse comprise à partir du texte libre.
  function confirmFree(target, qid, option, fromReplay) {
    if (!fromReplay) logAction({ a: 'freeOk', t: target, q: qid, v: option });
    removeInputs();
    if (target === 'current') {
      var q = currentSubQuestion() || currentQuestion();
      var idx = q ? (q.answers || []).findIndex(function (a) { return a.option === option; }) : -1;
      if (idx === -1) { repeatCurrentQuestion(); return; }
      answer(idx, true);          // la bulle utilisateur est poussée par answer()
      return;
    }
    addConcern(qid || CONCERN_MAIN_QID, option, true);
  }

  function declineFree(fromReplay) {
    if (!fromReplay) logAction({ a: 'freeNo' });
    removeInputs();
    push({ t: 'user', html: 'Non, pas tout à fait' });
    repeatCurrentQuestion();
  }

  // Ajoute une préoccupation exprimée librement sur le prochain emplacement libre.
  function addConcern(qid, option, fromReplay) {
    if (!fromReplay) logAction({ a: 'addConcern', q: qid, v: option });
    removeInputs();
    var q = E.findQuestion(qid);
    var ansObj = q && (q.answers || []).find(function (a) { return a.option === option; });
    if (!ansObj) { repeatCurrentQuestion(); return; }
    push({ t: 'user', html: esc(shortOption(option, 80)) });
    handleAnswerRecord(q, ansObj, null);
    state.skippedQids[qid] = true;   // la question ne sera pas reposée
    if (ansObj.has_sub_question && (ansObj.questions || []).length) {
      state.pendingSubs = state.pendingSubs.concat(ansObj.questions.map(function (sq) {
        var copy = Object.assign({}, sq);
        copy._parentOption = ansObj.option;
        return copy;
      }));
    }
    if (state.phase === 'routine') { state.phase = 'diagnostic'; state.surmesureOffered = false; }
    advance();
  }

  // Repose la question en cours après une parenthèse en texte libre.
  function repeatCurrentQuestion() {
    if (state.phase === 'routine' || state.phase === 'done') return;
    var sub = currentSubQuestion();
    var q = sub || currentQuestion();
    if (!q) return;
    say('<b>' + esc(q.question) + '</b>');
    push({ t: q.type === 'input' || q.type === 'optional-input' ? 'input' : 'chips', sub: !!sub });
  }

  function maybeShowCapture() {
    if (state.captureShown || !captureEnabled()) return;
    state.captureShown = true;
    say(S.capture);
    push({ t: 'capture' });
  }

  // --- Fin de parcours ---
  function finishProduct() {
    if (state.phase === 'done') return;
    state.phase = 'done';
    var text = E.resultText(state);
    state.resultText = text;

    E.track('Consultation Completed', {
      product: state.product,
      input_method: state.inputMethod,
      skin_code: E.skinCode(state.collected).skinType,
      active_ingredients: E.computeResultIngredients(state.collected)[state.product] || [],
    });
    E.identify(E.buildKlaviyoProps(Object.assign({}, state, { resultText: text })));

    say(S.doneIntro);
    push({ t: 'bilan' });
    maybeShowCapture();
    maybePostWorker();
    var next = ['serum', 'night_cream', 'daily_cream'].find(function (p) {
      return p !== state.product && !state.doneProducts.some(function (d) { return d.product === p; });
    });
    if (next) { say(S.crossSell[next]); push({ t: 'crosssell', product: next }); }
  }

  function startCrossSell(productKey, fromReplay) {
    if (!fromReplay) logAction({ a: 'crosssell', p: productKey });
    removeInputs();
    state.doneProducts.push({ product: state.product, fragrance: state.fragrance, texture: state.texture });
    state.phase = 'questions';
    state.product = productKey;
    state.qIndex = -1; state.pendingSubs = []; state.skipCount = 0;
    state.fragrance = null; state.texture = null;
    lastGroup = 'skin_type'; // pas de ré-intro : on enchaîne
    push({ t: 'user', html: S.crossSellYes });
    advance();
  }

  function declineCrossSell(fromReplay) {
    if (!fromReplay) logAction({ a: 'nocross' });
    removeInputs();
    push({ t: 'user', html: S.crossSellNo });
    say('Très bien 🤍 Votre formule vous attend dans « Ma formule » — à tout moment, ajoutez-la au panier.');
  }

  async function addSelectionToCart() {
    var btn = el('cb-cart-cta');
    if (btn) { btn.disabled = true; btn.textContent = 'Ajout en cours…'; }
    var all = state.doneProducts.concat(state.phase === 'done' && state.product
      ? [{ product: state.product, fragrance: state.fragrance, texture: state.texture }] : []);
    var ok = 0, ko = 0, lastData = null;
    for (var i = 0; i < all.length; i++) {
      var d = all[i];
      var st = Object.assign({}, state, { product: d.product, fragrance: d.fragrance, texture: d.texture });
      try { lastData = await E.addToCart(st, CFG); ok++; } catch (e) { ko++; }
    }
    E.track('Consultation Routine Added to Cart', { products: all.map(function (d) { return d.product; }), products_added: ok, products_failed: ko });
    if (btn) { btn.disabled = false; btn.textContent = ok ? '✓ Votre formule est dans le panier' : 'Réessayer'; }
    if (ok) {
      refreshCartDrawer(lastData);
      say(S.cartAdded);
    }
  }

  // Rafraîchit et ouvre le drawer panier du thème avec les sections renvoyées par /cart/add.js
  function refreshCartDrawer(data) {
    try {
      var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      if (data && data.sections && drawer && typeof drawer.renderContents === 'function') {
        drawer.renderContents(data);
        return;
      }
      // filet de sécurité : au moins la pastille du panier
      if (data && data.sections && data.sections['cart-icon-bubble']) {
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble) bubble.innerHTML = data.sections['cart-icon-bubble'];
      }
    } catch (e) { /* jamais bloquant */ }
  }

  // --- Worker + capture Klaviyo ---
  function maybePostWorker(email) {
    if (state.workerSent) return;
    var mail = email || (window.customer && window.customer.email) || state.email;
    if (!mail) return;
    state.workerSent = true;
    var quizData = E.buildQuizData(Object.assign({}, state, { resultContent: { text: state.resultText || '' } }));
    E.postWorker(mail, quizData);
  }

  // --- Onglets mobile ---
  function showTab(name) {
    var rootEl = el('cb-root');
    if (!rootEl) return;
    rootEl.setAttribute('data-tab', name);
    ['chat', 'profile', 'selection'].forEach(function (t) {
      var tab = el('cb-tab-' + t);
      if (tab) tab.classList.toggle('cb-on', t === name);
    });
  }

  // --- Déroulé initial & reprise ---
  function start() {
    say(S.welcome);
    say(S.welcomeAsk);
    push({ t: 'open-input' });
    state.phase = 'welcome';
  }

  function replay(actions) {
    instant = true;
    start();
    actions.forEach(function (act) {
      if (act.a === 'product') chooseProduct(act.p, true);
      else if (act.a === 'open') submitOpenConcern(true, act.v);
      else if (act.a === 'concern') chooseConcern(act.v, true);
      else if (act.a === 'concernNo') rejectConcern(true);
      else if (act.a === 'free') submitFree(true, act.v, act.r);
      else if (act.a === 'freeOk') confirmFree(act.t, act.q, act.v, true);
      else if (act.a === 'freeNo') declineFree(true);
      else if (act.a === 'addConcern') addConcern(act.q, act.v, true);
      else if (act.a === 'reco') addRecoToCart(act.h, true);
      else if (act.a === 'sm') acceptSurMesure(true);
      else if (act.a === 'smNo') declineSurMesure(true);
      else if (act.a === 'answer') answer(act.i, true);
      else if (act.a === 'input') submitInput(true, act.v);
      else if (act.a === 'skip') skipInput(true);
      else if (act.a === 'crosssell') startCrossSell(act.p, true);
      else if (act.a === 'nocross') declineCrossSell(true);
      else if (act.a === 'photoDecline') declinePhoto(true);
      else if (act.a === 'photoConfirm') { state.photoResult = act.res; confirmPhoto(act.ok, true); }
    });
    // la file de messages est asynchrone : ne repasser en mode normal qu'une fois
    // tout le rejeu rendu, sinon chaque bulle rejoue son animation de frappe
    queue = queue.then(function () { instant = false; });
  }

  function init() {
    var saved = null;
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (raw) {
        var parsed = JSON.parse(raw);
        if (parsed && parsed.ts && Date.now() - parsed.ts < 2 * 60 * 60 * 1000) saved = parsed;
      }
    } catch (e) {}
    var photoInput = el('cb-photo-input');
    if (photoInput) photoInput.addEventListener('change', function (e) {
      onPhotoFile(e.target.files && e.target.files[0]);
      e.target.value = '';
    });
    if (saved && saved.actions && saved.actions.length) {
      state.actions = saved.actions.slice();
      replay(saved.actions);
    } else {
      start();
    }
    showTab('chat');
  }

  window.LaboteConsultation = {
    chooseProduct: chooseProduct, answer: answer, submitInput: submitInput, skipInput: skipInput,
    submitOpenConcern: submitOpenConcern, chooseConcern: chooseConcern, rejectConcern: rejectConcern,
    addConcern: addConcern, submitFree: submitFree,
    confirmFree: confirmFree, declineFree: declineFree,
    addRecoToCart: addRecoToCart, acceptSurMesure: acceptSurMesure, declineSurMesure: declineSurMesure,
    startCrossSell: startCrossSell, declineCrossSell: declineCrossSell,
    addSelectionToCart: addSelectionToCart, showTab: showTab, submitCapture: submitCapture,
    choosePhoto: choosePhoto, declinePhoto: declinePhoto, confirmPhoto: confirmPhoto,
    _handleVision: handleVision, _onPhotoFile: onPhotoFile,
    restart: function () {
      try { sessionStorage.removeItem(STORAGE_KEY); } catch (e) {}
      state.product = null; state.collected = []; state.fragrance = null; state.texture = null;
      state.doneProducts = []; state.transcript = []; state.actions = [];
      state.qIndex = -1; state.pendingSubs = []; state.skipCount = 0; state.skippedQids = {};
      state.phase = 'welcome'; state.workerSent = false; lastGroup = null;
      state.dateOfBirth = ''; state.nameOnBox = ''; state.note = ''; state.additionalInformation = '';
      state.firstName = ''; state.email = null; state.resultText = '';
      state.photoOffered = false; state.photoThumb = null; state.photoResult = null;
      state.photoRetryUsed = false; state.suggested = {}; state.autoConcerns = [];
      state.routine = null; state.routineCart = {}; state.freeCount = 0;
      state.openAnswered = false; state.surmesureOffered = false; state.captureShown = false;
      delete state._asked_nameOnBox; delete state._asked_note; delete state._asked_additionalInformation;
      start();
    },
    _state: state, _setInstant: function (v) { instant = v; },
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
